import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Actions, { thunks } from '../../redux/modules/productSearch';
import { formatCategory } from '../../utils/format';
import Loader from "../Loader";
import Pagination from '../Pagination';
import ImagePlaceholder from '../../assets/img/img_placeholder.jpg';

class ProductSearchModal extends Component {
    onInputChange = e => {
        this.props.updateProperty('search', e.target.value)
    }

    onSearch = () => {
        if (this.props.search) this.props.dispatch(thunks.searchProducts())
    }

    onNext = () => {
        const { dispatch } = this.props;
        dispatch(thunks.loadMoreProducts());
    }

    selectProduct = product => {
        this.props.onSelect(product);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.show !== this.props.show) {
            this.props.reset();
        }
    }

    render() {
        const {
            show,
            loading,
            error,
            list,
            search,
            nextPageToken,
            onHide,
        } = this.props;

        return(
            <Modal
                show={show}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                       Product Search
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12 mb-3">
                        <div class="input-group">
                            <input type="text" class="form-control" value={search} onChange={this.onInputChange}/>
                            <button type="button" class="btn btn-outline-secondary" onClick={this.onSearch}>Search</button>
                        </div>
                        </div>
                        <div className="col-md-12">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Title</th>
                                            <th>Image</th>
                                            <th>Category</th>
                                            <th/>
                                        </tr>
                                    </thead>
                                    <tbody>
                                            {
                                                loading ? (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">
                                                            <Loader show noOverlay/>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    list.length ? (
                                                        list.map(product => (
                                                            <tr key={product.productId}>
                                                                <td>{product.productId}</td>
                                                                <td>{product.title}</td>
                                                                <td>
                                                                    {<img src={product.productImages.length ? product.productImages[0] : ImagePlaceholder} alt={product.title} width="80px"/>}    
                                                                </td>
                                                                <td>{formatCategory(product.categoryName)}</td>
                                                                <td>
                                                                    <button title="Select" className="btn btn-xs btn-primary ml-2" onClick={() => this.selectProduct(product)}>
                                                                        <i className="fa fa-plus"/>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        error ? (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">{error}</td>
                                                            </tr>
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">No Products Found</td>
                                                            </tr>
                                                        )
                                                    )
                                                )
                                            }
                                    </tbody>
                                </table>
                            </div>
                            <Pagination
                                nextPageToken={nextPageToken}
                                onNext={this.onNext}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger" onClick={onHide}>Close</button>
                </Modal.Footer>
            </Modal>
        )
    }
}

const mapStateToProps = ({
    productSearch: {
        loading,
        error,
        list,
        search,
        nextPageToken,
    },
}) => ({
    loading,
    error,
    list,
    search,
    nextPageToken,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
    reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductSearchModal)